import { RouteConfig } from 'vue-router';
import CatpProtection from './catp-protection.component.vue';

export const CatpProtectionRoute: RouteConfig = {// tslint:disable-line:variable-name
  path: 'catp-protection',
  component: CatpProtection,
};

export function getDefaultParams() {
  return {};
}
